import React, { useState, useEffect } from "react";
import TextField from "../../../components/formcomponents/TextField";
import { FaFileUpload } from "react-icons/fa";
import TextArea from "../../../components/formcomponents/TextArea";
import { useCallback } from "react";
import Panels from "../Panels";
import Sponser from "../Sponser";
import { Calendar, Plus, Trash2 } from 'lucide-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from 'react-icons/fa';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { submitHackathonForm } from "../../../redux/actions/action";


const HackathonForm = ({ onClose }) => {

  const [formData, setFormData] = useState({
    eventName: "",
    technology: "",
    projectDetails: "",
    description: "",
    teamFormation: "",
    Mentors: [],
    firstPrize: "",
    secondPrize: "",
    otherPrizes: [],  // Ensure this is a valid JSON array
    Judges: [],
    agendas: [],
    Sponsors: [],
    RulesandGuidelines: "",
    eventPlatform: "",
    duration: "",
    lastRegistrationDate: null
  });

  const [descriptionWordCount, setDescriptionWordCount] = useState(0);
  const [rulesWordCount, setRulesWordCount] = useState(0);
  const [prizes, setPrizes] = useState([""]); // To hold the prize fields
  const [mentors, setMentors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [mentorCriteria, setMentorCriteria] = useState('');
  const [modalType, setModalType] = useState(null);
  const [sponsors, setSponsors] = useState([]);
  const [judges, setJudges] = useState([]);
  const [judgeCriteria, setJudgeCriteria] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // Track submission status

  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();

  //Agenda
  const [agendas, setAgendas] = useState([
    { text: "", date: null }
  ]);
  const [agendaErrors, setAgendaErrors] = useState([
  { date: '', text: '' }
]);
  const handleAgendaChange = (index, key, value) => {
    const updatedAgendas = [...agendas];
    updatedAgendas[index][key] = value;
    setAgendas(updatedAgendas);
  };
  const addAgenda = () => {
    setAgendas([...agendas, { text: "", date: null }]);
    setAgendaErrors([...agendaErrors, { text: "", date: "" }]);
  };
  const handleRemoveAgenda = (index) => {
    setAgendas((prevagendas) => prevagendas.filter((_, i) => i !== index));
     setAgendaErrors(agendaErrors.filter((_, i) => i !== index));
  };

  // Custom Input with Calendar Icon Inside Textarea
  const CustomDateTextArea = forwardRef(({ value, onClick, placeholder }, ref) => (
    <div
      onClick={onClick}
      ref={ref}
      className="w-full flex items-center gap-2 px-3 py-2 bg-white rounded-md border border-gray-300 text-sm text-gray-900 cursor-pointer"
    >
      <input
        type="text"
        value={value || ''}
        placeholder="Select date and time"
        readOnly
        className="w-full rounded-md text-black mb-1 "
      />
      <FaCalendarAlt className="text-purple-700" size={18} />
    </div>
  ));


  //Description and Rules and guidelines
  const getWordCount = (text) => {
    return text.trim().split(/\s+/).filter(Boolean).length;
  };

  //bullet for Rules and guidelines
  useEffect(() => {
    if (!formData.RulesandGuidelines) {
      setFormData(prev => ({ ...prev, RulesandGuidelines: '• ' })); `                                              `
    }
  }, []);

  //Prizes and Awards
  const handleRemovePrize = (index) => {
    setPrizes((prevPrizes) => prevPrizes.filter((_, i) => i !== index));
  };
  const handlePrizeChange = (index, event) => {
    const newPrizes = [...prizes];
    newPrizes[index] = event.target.value;
    setPrizes(newPrizes);
  };
  const handleAddPrize = () => {
    setPrizes([...prizes, ""]); // Add new field to the list
  };
  //Mentors
  const handleSubmitPanel = (submittedMentors) => {
    setMentors((prev) => [...prev, ...submittedMentors]);
    setShowModal(false);
  };

  const handleRemoveMentor = (index) => {
    setMentors((prev) => prev.filter((_, i) => i !== index));
  };

  const handlejudgepanel = (submittedJudges) => {
    setJudges((prev) => [...prev, ...submittedJudges]);
    setShowModal(false);
  };

  const handleRemoveJudge = (index) => {
    setJudges((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSponsorSubmit = (newSponsors) => {
    setSponsors([...sponsors, ...newSponsors]); // Add multiple if needed
    setShowModal(false);
  };

  const handleRemoveSponsor = (index) => {
    const updated = [...sponsors];
    updated.splice(index, 1);
    setSponsors(updated);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    validateField(name, value);
  };
  function toFakeUTCISOString(date) {
    const pad = (n) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.000Z`;
  }


  // Validation function
  const validateField = (name, value) => {
    let error = "";
    // const today = new Date();
    const wordCount = (text) => text.trim().split(/\s+/).filter(Boolean).length;

    switch (name) {
      case "eventName":
        if (!value.trim()) {
          error = "Event Name is required.";
        } else if (value.trim().length < 3) {
          error = "Event Name must be at least 3 characters.";
        } else if (!/^[A-Za-z0-9\s]+$/.test(value)) {
          error = "Event Name must contain only alphanumeric characters.";
        }
        break;

      case "projectDetails":
        if (!value.trim()) {
          error = "project Details are required.";
        } else if (wordCount(value) < 5) {
          error = "Project details must be at least 5 words.";
        }
        else if (wordCount(value) > 100) {
          error = "Project details must not exceed 100 words.";
        }
        break;


      case "teamFormation":
        if (!value.trim()) {
          error = "Team Formation is required.";
        } else if (/^\d+$/.test(value.trim())) {
          // It's a number, valid case
          const num = parseInt(value.trim(), 10);
          if (num <= 0) {
            error = "Team size must be a positive number.";
          }
        } else {
          // Not a number, validate as sentence
          const words = wordCount(value);
          if (words < 5) {
            error = "Team Formation Rules must be at least 5 words if not a number.";
          } else if (words > 100) {
            error = "Team Formation must not exceed 100 words.";
          }
        }
        break;

      case "Mentors:":
        if (!value || value.length === 0) {
          error = "At least one mentor is required.";
        }
        break;

      case "Judges:":
        if (!value || value.length === 0) {
          error = "At least one judge is required.";
        }
        break;

      case "Sponsors:":
        if (!value || value.length === 0) {
          error = "At least one sponsor is required.";
        }
        break;

      case "technology":
        if (!value.trim()) {
          error = "Technology is required.";
        } else if (!/^[A-Za-z0-9\s]+$/.test(value)) {
          error = "Technology must contain only alphanumeric characters.";
        }
        break;

      case "description":
        if (!value.trim()) {
          error = "Description is required.";
        } else if (wordCount(value) < 5) {
          error = "Description must be at least 5 words.";
        }
        else if (wordCount(value) > 100) {
          error = "Description must not exceed 100 words.";
        }
        break;

      case "RulesandGuidelines":
        if (!value.trim()) {
          error = "RulesandGuidelines  are required.";
        } else if (wordCount(value) < 5) {
          error = "RulesandGuidelines  must be at least 5 words.";
        }
        else if (wordCount(value) > 100) {
          error = "RulesandGuidelines  must not exceed 100 words.";
        }
        break;

      case "lastRegistrationDate":
        if (!value) {
          error = "Last registration date is required.";
        } else {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // remove time component
          const tomorrow = new Date(today);
          tomorrow.setDate(tomorrow.getDate() + 1); // move to next day

          const selectedDate = new Date(value);
          selectedDate.setHours(0, 0, 0, 0); // normalize selected date

          if (selectedDate < tomorrow) {
            error = "Last registration date must be at least one day in the future.";
          }
        }
        break;
      case "firstPrize":
        if (!value.trim()) {
          error = "First Prize is required.";
        }
        break;

      case "secondPrize":
        if (!value.trim()) {
          error = "Second Prize  and  prize 3 is required.";
        }
        break;


      default:
        break;
    }

    console.log(`Validation result for ${name}: ${error}`); // Debugging log
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const validationErrors = {};

    // Validate each field using validateField and collect errors
    Object.keys(formData).forEach((field) => {
      validateField(field, formData[field]);
      if (errors[field]) {
        validationErrors[field] = errors[field];
      }
    });


    // ✅ Manually validate mentors
    if (mentors.length === 0) {
      validationErrors.mentors = "At least one mentor is required.";
    }

    // ✅ Manually validate judges
    if (judges.length === 0) {
      validationErrors.judges = "At least one judge is required.";
    }

    // ✅ Manually validate sponsors
    if (sponsors.length === 0) {
      validationErrors.sponsors = "At least one sponsor is required.";
    }

    // Validate agendas 
if (!formData.lastRegistrationDate) {
  validationErrors.lastRegistrationDate = "Last registration date is required to validate agendas.";
} else {
  const registrationDate = new Date(formData.lastRegistrationDate);
  // agendas.forEach((agenda, index) => {
  //   if (!agenda.date) {
  //     validationErrors[`agenda_${index}`] = `Agenda ${index + 1} must have a date.`;
  //   } else if (new Date(agenda.date) < registrationDate) {
  //     validationErrors[`agenda_${index}`] = `Agenda ${index + 1} must be after the registration deadline.`;
  //   }
  // });
 //const agendaErrs: { date: string; text: string }[] = agendas.map(() => ({ date: "", text: "" }));

agendas.forEach((agenda, index) => {
  if (!agenda.date) {
    const msg = `Agenda ${index + 1} must have a date.`;
    validationErrors[`agenda_${index}`] = msg;
    agendaErrors[index].date = msg;
  } else if (new Date(agenda.date) < registrationDate) {
    const msg = `Agenda ${index + 1} must be after the registration deadline.`;
    validationErrors[`agenda_${index}`] = msg;
    agendaErrors[index].date = msg;
  }
});

setAgendaErrors(agendaErrors);

}

    // If validation errors exist, update state and exit
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.error("Validation failed:", validationErrors);
      setIsSubmitting(false);
      return;
    }

    // Remove preview fields
    const cleanMentors = mentors.map(({ preview, ...rest }) => rest);
    const cleanJudges = judges.map(({ preview, ...rest }) => rest);
    const updatedFormData = {
      ...formData,
      //lastRegistrationDate: formData.lastRegistrationDate.toLocaleString(),// ⬅️ formatted in local time
      lastRegistrationDate: toFakeUTCISOString(formData.lastRegistrationDate), // ✅ Custom format
      otherPrizes: prizes, agendas, Mentors: cleanMentors, Judges: cleanJudges, Sponsors: sponsors
    };
    console.log("Prizes:", prizes);
    console.log("Agendas:", agendas);
    console.log("Mentors:", cleanMentors);
    console.log("Judges:", cleanJudges);
    console.log("Sponsors:", sponsors);
    console.log("Cleaned Data:", updatedFormData);
    // Dispatch updatedFormData to Redux
    dispatch(submitHackathonForm(updatedFormData));  // Update Redux store with the form data
    console.log("Hackathon Form Data to send to the backend:", updatedFormData);
    setTimeout(() => {
      console.log("Hackathon Form Submitted", JSON.stringify(updatedFormData, null, 2));
      setIsSubmitting(false);
      onClose();
    }, 5000);
  };



  return (
    //<div className="absolute top-[10px] left-[-1050px] bg-color p-6 rounded-lg shadow-lg w-[750px] min-h-[1000px] max-h-[80vh]  font-poppins overflow-y-auto">
    //<div className="absolute top-[10px] left-1/2 transform -translate-x-1/2 bg-color p-6 rounded-lg shadow-lg w-[750px] min-h-[1000px] max-h-[80vh] font-poppins overflow-y-auto">
    <div className="fixed top-10 left-1/2 transform -translate-x-1/2 bg-color p-6 rounded-lg shadow-lg w-[750px] max-h-[90vh] overflow-y-auto font-poppins">

      <form onSubmit={handleSubmit}>
        <div className="flex flex-col md:flex-row gap-4">

          {/* LEFT COLUMN */}
          <div className="flex flex-col gap-4 w-full md:w-1/2 p-4 bg-[#4B2B8B] font-poppins rounded-2xl text-white">
            {/* Event Name */}
            <div>
              <label className="block mb-1">Event Name*</label>
              <input
                type="text"
                name="eventName"
                value={formData.eventName}
                onChange={handleChange}
                required
                placeholder="Enter event name"
                className="w-full p-2 rounded-md text-black"
              />
              {errors.eventName && (
                <p className="text-red-400 text-sm mt-1">{errors.eventName}</p>
              )}
            </div>

            {/* Project Details */}
            <div>
              <label className="block mb-1">Project Details</label>
              <input
                type="text"
                name="projectDetails"
                value={formData.projectDetails}
                onChange={handleChange}
                required
                placeholder="Enter project details"
                className="w-full p-2 rounded-md text-black"
              />
              {errors.projectDetails && (
                <p className="text-red-400 text-sm mt-1">{errors.projectDetails}</p>
              )}
            </div>

            {/* Team Formation */}
            <div>
              <label className="block mb-1">Team Formation</label>
              <input
                name="teamFormation"
                value={formData.teamFormation}
                onChange={handleChange}
                required
                placeholder="Enter team formation rules"
                className="w-full p-2 rounded-md text-black"
              />
              {errors.teamFormation && (
                <p className="text-red-400 text-sm mt-1">{errors.teamFormation}</p>
              )}
            </div>

            {/* Prizes */}
            <div>
              <label className="block mb-1">Prize and Awards details</label>
              <input type="text" name="firstPrize" value={formData.firstPrize} onChange={handleChange} placeholder="Enter first prize" className="w-full p-2 rounded-md text-black mb-2" />
              {errors.firstPrize && <p className="text-red-400 text-sm mt-1">{errors.firstPrize}</p>}
              <input type="text" name="secondPrize" value={formData.secondPrize} onChange={handleChange} placeholder="Enter second prize" className="w-full p-2 rounded-md text-black mb-2" />
              {errors.secondPrize && <p className="text-red-400 text-sm mt-1">{errors.secondPrize}</p>}
              {prizes.map((prize, index) => (
                <div key={index} className="flex items-center gap-2 mb-2">
                  <input
                    type="text"
                    value={prize}
                    onChange={(e) => handlePrizeChange(index, e)}
                    placeholder={`Enter prize ${index + 3}`}
                    className="w-full p-2 rounded-md text-black"
                  />
                  <button type="button" onClick={() => handleRemovePrize(index)} className="bg-red-500 text-white px-2 py-1 rounded-md">X</button>
                </div>
              ))}
              <button type="button" onClick={handleAddPrize} className="bg-white text-black px-3 py-1 rounded-md">+ Add Prize</button>
            </div>

            {/* Agenda */}
            <div>
              <label className="block mb-1">Agenda*</label>
              {agendas.map((agenda, index) => (
                <div key={index} className="relative mb-2">
                  <div className="relative w-full z-50"> {/* z-50 prevents layering issues */}
                    {/* Date and time picker */}
                    <DatePicker
                      selected={agenda.date}
                      onChange={(date) => handleAgendaChange(index, 'date', date)}
                      //onChange={(date) => handleDateChange(index, 'date', date)}
                      
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      placeholder="Select date and time"
                      // placeholderText="Select date and time"
                      customInput={<CustomDateTextArea />}
                      popperPlacement="bottom-start"
                      minDate={new Date()} // ✅ This line restricts past dates
                      popperProps={{
                        modifiers: [
                          {
                            name: 'preventOverflow',
                            options: {
                              boundary: 'viewport', // prevents going out of screen
                            },
                          },
                          {
                            name: 'offset',
                            options: {
                              offset: [0, 8], // optional: adds space between input and calendar
                            },
                          },
                        ]
                      }}
                    />
                    {/* Error below datepicker */}
      {agendaErrors[index]?.date && (
        <p className="text-red-500 text-sm mt-1">{agendaErrors[index].date}</p>
      )}
                    <button
                      type="button"
                      onClick={() => handleRemoveAgenda(index)}
                      className="absolute right-2 top-2 bg-red-500 text-white px-2 py-1 rounded-md"
                    >
                      X
                    </button>
                  </div>

                  {/* Agenda textarea */}
                  <textarea
                    placeholder={`Enter Day ${index + 1} Agenda`}
                    value={agenda.text}
                    onChange={(e) => handleAgendaChange(index, 'text', e.target.value)}
                    className="w-full mt-2 p-2 rounded-md text-black border border-gray-300 resize-none"
                    rows={2}
                  />
                   {agendaErrors[index]?.text && (
      <p className="text-red-500 text-sm">{agendaErrors[index].text}</p>
    )}
                </div>
              ))}

              {/* Add Agenda Button */}
              <button
                type="button"
                onClick={addAgenda}
                className="bg-white text-black px-3 py-1 rounded-md"
              >
                + Add Agenda
              </button>
            </div>
          </div>



          {/* RIGHT COLUMN */}

          <div className="flex flex-col gap-1 w-full md:w-1/2 p-4 bg-[#4B2B8B] font-poppins rounded-2xl text-white">

            {/* Technology */}
            <div>
              <label className="block mb-2">Technology*</label>
              <input
                type="text"
                name="technology"
                value={formData.technology}
                onChange={handleChange}
                required
                placeholder="Enter technology"
                className="w-full p-2 rounded-md text-black"
              />
              {errors.technology && (<p className="text-red-400 text-sm mt-1">{errors.technology}</p>)}
            </div>

            {/* Description */}
            <div>
              <label className="block mb-2">Description*</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                // onChange={(e) => {
                //   const text = e.target.value;
                //   const wordCount = getWordCount(text);
                //   if (wordCount <= 100) {
                //     setFormData({ ...formData, description: text });
                //     setDescriptionWordCount(wordCount); // update word count

                //   }
                // }}
                placeholder="Enter description in 5-100 words"
                className="w-full p-2 rounded-md text-black"
                rows={4}
              />
              {/* <p className="text-sm mt-1" style={{ color: descriptionWordCount < 5 ? 'red' : 'green' }}>
                {descriptionWordCount} words (Min: 5, Max: 100)
              </p> */}
              {errors.description && (<p className="text-red-400 text-sm mt-1">{errors.description}</p>)}
            </div>

            {/* Mentors */}
            <div className="mb-3 w-full max-w-xl mx-auto">
              <label className="block mb-2 text-white font-semibold">Mentors</label>
              {/* Container for textarea + +button */}
              <div className="relative">
                <textarea
                  className="w-full p-2 rounded-md text-black"
                  rows={4}
                  maxLength={800}
                  placeholder="Enter mentor selection criteria (50–100 words)"
                  value={mentorCriteria}
                  onChange={(e) => setMentorCriteria(e.target.value)}
                />

                {/* + Button */}
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(true);
                    setModalType('mentor');
                  }}
                  className="absolute top-1 right-1 bg-white  px-2 py-1 rounded-md shadow-sm hover:bg-gray-100"
                  title="Add Mentor"
                >
                  <Plus className="w-4 h-4" strokeWidth={4} />
                </button>
              </div>
              {/* 👇 This shows how many mentors you've added */}
              <p className="text-sm text-gray-300 mt-1 mb-0">
                {mentors.length > 0
                  ? `${mentors.length} mentor${mentors.length > 1 ? 's' : ''} added`
                  : "No mentors added yet"}
              </p>

              {/* 👇 Display mentor-related validation error */}
              {errors.mentors && (
                <p className="text-red-400 text-sm mt-1">{errors.mentors}</p>
              )}
              {/* Panel Modal */}
              {showModal && modalType === 'mentor' && (
                <Panels
                  type="mentor"
                  onClose={() => setShowModal(false)}
                  onSubmit={handleSubmitPanel}
                />
              )}
            </div>


            {/* Judges */}
            <div className="mb-3 w-full max-w-xl mx-auto">
              <label className="block mb-2 text-white font-semibold">Judges</label>

              {/* Container for textarea + +button */}
              <div className="relative">
                <textarea
                  className="w-full p-2 rounded-md text-black"
                  rows={4}
                  maxLength={800}
                  placeholder="Enter Judges selection criteria (50–100 words)"
                  value={judgeCriteria}
                  onChange={(e) => setJudgeCriteria(e.target.value)}
                />
                {/* + Button */}
                <button
                  type="button"
                  onClick={() => {
                    setModalType('judge');
                    setShowModal(true);
                  }}
                  className="absolute top-1 right-1 bg-white  px-2 py-1 rounded-md shadow-sm hover:bg-gray-100">
                  <Plus className="w-4 h-4" strokeWidth={4} />
                </button>
              </div>
              {/* 👇 This shows how many judges you've added */}
              <p className="text-sm text-gray-300 mt-1 mb-0">
                {judges.length > 0
                  ? `${judges.length} Judge${judges.length > 1 ? 's' : ''} added`
                  : "No judges added yet"}
              </p>
              
              {errors.judges && (
                <p className="text-red-400 text-sm mt-1">{errors.judges}</p>
              )}

              {showModal && modalType === 'judge' && (
                <Panels
                  type="judge"
                  onClose={() => setShowModal(false)}
                  onSubmit={handlejudgepanel}

                />
              )}
            </div>

            {/* Sponsors */}

            <div className="mb-3 w-full max-w-xl mx-auto">
              <label className="block mb-2 text-white font-semibold">Sponsors</label>
              {/* Container for logo images and + button */}
              <div className="relative bg-white rounded-md p-3 flex flex-wrap gap-2 min-h-[100px]">
                {/* Logos */}
                {sponsors.map((s, i) => (
                  <div key={i} className="w-[60px] h-[60px] border border-gray-300 rounded-md overflow-hidden bg-white shadow">
                    {s.preview ? (
                      <img
                        src={s.preview}
                        alt={`Sponsor ${i + 1}`}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">
                        No Logo
                      </div>
                    )}
                  </div>
                ))}

                {/* + Button */}
                <button
                  type="button"
                  onClick={() => {
                    setModalType('sponsor');
                    setShowModal(true);
                  }}
                  className="absolute top-1 right-1 bg-white  px-2 py-1 rounded-md shadow-sm hover:bg-gray-100"
                >
                  <Plus className="w-4 h-4" strokeWidth={4} />

                </button>
              </div>
              {/* 👇 This shows how many sponsors you've added */}
              <p className="text-sm text-gray-300 mt-1 mb-0">
                {sponsors.length > 0
                  ? `${sponsors.length} sponser${sponsors.length > 1 ? 's' : ''} added`
                  : "No sponsors added yet"}
              </p>
              {errors.sponsors && (
                <p className="text-red-400 text-sm mt-1">{errors.sponsors}</p>
              )}

              {showModal && modalType === 'sponsor' && (
                <Sponser
                  onClose={() => setShowModal(false)}
                  onSubmit={(data) => {
                    //console.log("Received in parent:", data); // ✅ add this
                    handleSponsorSubmit(data); // your actual function
                  }}
                />
              )}
            </div>


            {/* Rules and Guidelines */}
            <div>
              <label className="block mb-1">Rules and Guidelines</label>
              <textarea
                name="RulesandGuidelines"
                value={formData.RulesandGuidelines}
                onChange={handleChange}
                // onChange={(e) => {
                //   let text = e.target.value;

                //   // Auto add bullets when pressing enter
                //   if (text[text.length - 1] === '\n') {
                //     text += '• ';
                //   }

                //   const wordCount = getWordCount(text);

                //   if (wordCount <= 100) {
                //     setFormData({ ...formData, RulesandGuidelines: text });
                //     setRulesWordCount(wordCount);
                //   }
                // }}
                placeholder="Enter rules and guidelines while forming team"
                className="w-full p-2 rounded-md text-black"
              />
              {errors.RulesandGuidelines && (<p className="text-red-400 text-sm mt-1">{errors.RulesandGuidelines}</p>)}
            </div>

            {/* Hackathon Info */}
            <div>
              <label className="block mb-2">INNOHUB OPEN HACKATHON</label>

              {/*Program duration*/}
              <select
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                className="w-full p-2 rounded-md text-black mb-2"
              >
                <option value="">Enter program duration</option>
                <option value="15m">15 Minutes</option>
                <option value="30m">30 Minutes</option>
                <option value="1h">1 Hour</option>
                <option value="2h">2 Hours</option>
                <option value="4h">4 Hours</option>
                <option value="1d">1 Day</option>
                <option value="3d">3 Days</option>
                <option value="1w">1 Week</option>
                <option value="2w">2 Weeks</option>
                <option value="1m">1 Month</option>
                <option value="3m">3 Months</option>
                <option value="6m">6 Months</option>
                <option value="1y">1 Year</option>
              </select>



              {/*Application Deadline*/}
              <DatePicker
                selected={formData.lastRegistrationDate}
                onChange={(date) =>
                  setFormData({ ...formData, lastRegistrationDate: date })
                }
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText="Select application deadline"
                //minDate={new Date()} // ✅ This line restricts past dates
                minDate={new Date(new Date().setDate(new Date().getDate() + 1))} // ✅ At least tomorrow
                className="w-full p-2 rounded-md text-black mb-2"
              />
              {errors.lastRegistrationDate && (<p className="text-red-400 text-sm mt-1">{errors.lastRegistrationDate}</p>)}
              {/*virual /offline*/}
              <select
                name="eventPlatform"
                value={formData.eventPlatform}
                onChange={handleChange}
                className="w-full p-2 rounded-md text-black"
              >
                <option value="">Select Platform</option>
                <option value="Virtual">Virtual</option>
                <option value="Offline">Offline</option>
              </select>
            </div>
          </div>
        </div>

        {/* Submit and Cancel Buttons */}
        <div className="flex justify-center mt-6 gap-4">
          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-600"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default HackathonForm;